import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Input, Label, Row } from 'reactstrap';
import OSelect from '../../../../Components/OElements/OSelect';
import PageComponents from './Graph/PageComponents';
import { useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { getGraphList } from '../../../../slices/thunks';
import moment from 'moment';

const TitleTextGraphPage = ({ elements, page, handleDynamicChange, validation, edit, date_ini, date_end }) => {
    const text = elements.length > 0 ? elements[0].text : '';
    const graph = elements.length > 0 ? elements[0].graph : '';

    const dispatch = useDispatch();

    const selectorReport = createSelector(
        state => state.Screen,
        report => ({
            data: report.graphList || []  // Asegura que data sea un array vacío si es null o undefined
        })
    );

    const { data } = useSelector(selectorReport);

    const [graphNoEdit, setGraphNoEdit] = useState(null);
    const [selectedGraph, setSelectedGraph] = useState(graph);
    const [selectedGraphCode, setSelectedGraphCode] = useState(null);
    const [typesList, setTypesList] = useState([]);
    const [calculatedDates, setCalculatedDates] = useState({ date_ini: null, date_end: null });

    const handleGraphSelect = (optionSelected) => {
        if (optionSelected?._id !== selectedGraph?._id) {
            setSelectedGraph(optionSelected);
            setSelectedGraphCode(optionSelected?.code);
            handleDynamicChange(0, 'graph', optionSelected?._id);
        }
    };

    useEffect(() => {
        dispatch(getGraphList());
    }, [dispatch]);

    useEffect(() => {
        if (Array.isArray(data) && data.length > 0) {  // Verifica que data sea un array y tenga elementos antes de mapear
            const list = data.map(type => ({
                value: type._id,
                label: type.name,
                item: type
            }));
            setTypesList(list);

            if (graph) {
                const foundType = data.find(type => type._id === graph);
                setGraphNoEdit(foundType);
            }
        }
    }, [data, graph]);

    useEffect(() => {
        const calculateDates = () => {
            let startDate, endDate;

            if (date_ini && date_end) {
                startDate = moment(date_ini).startOf('month').subtract(11, 'months');
                endDate = moment(date_end).endOf('month');
            } else {
                // Si no se proporcionan fechas, se calculan en función del mes actual
                endDate = moment().endOf('month');
                startDate = moment().startOf('month').subtract(11, 'months');
            }

            return { date_ini: startDate.toDate(), date_end: endDate.toDate() };
        };

        setCalculatedDates(calculateDates());
    }, [date_ini, date_end]);

    const SelectedGraphComponent = edit
        ? PageComponents[selectedGraphCode]
        : PageComponents[graphNoEdit?.code];

    return (
        <Card className='border card-border-primary'>
            <Row className="g-0">
                <Col md={3} className="bg-primary text-white">
                    <Row className="g-0">
                        <Col md={12} className='p-2'>
                            <Label for="text" className="form-label">
                                Texto
                            </Label>
                            <Input
                                name="text"
                                id="text"
                                className="form-control"
                                placeholder="Ingrese un texto"
                                type="textarea"
                                value={text}
                                rows={10}
                                onChange={(e) => handleDynamicChange(0, 'text', e.target.value, page)}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md={9}>
                    <CardBody>
                        {edit && typesList.length > 0 ? (
                            <Col md={6}>
                                <OSelect
                                    label="Gráfico"
                                    id="graph"
                                    name="graph"
                                    value={graph}
                                    onSelect={handleGraphSelect}
                                    itemsSelect={typesList}
                                    validation={validation}
                                />
                            </Col>
                        ) : null}
                        <Col md={12}>
                            {SelectedGraphComponent && (
                                <div style={{ height: '300px' }}>
                                    <React.Suspense fallback={<div>Cargando...</div>}>
                                        <SelectedGraphComponent
                                            date_ini={calculatedDates.date_ini}
                                            date_end={calculatedDates.date_end}
                                        />
                                    </React.Suspense>
                                </div>
                            )}
                        </Col>
                    </CardBody>
                </Col>
            </Row>
        </Card>
    );
};

export default TitleTextGraphPage;
